import { CHANGE_SIDENAV, SET_CLIENT_PRESECTION } from '../actions/types'

const initialState = false

const sidenavReducer = (state = initialState, action) => {
  switch (action.type) {
    case CHANGE_SIDENAV:
      return action.payload
    default:
      return state
  }
}
export const presectionReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_CLIENT_PRESECTION:
      return action.payload
    default:
      return state
  }
}

export default sidenavReducer
